<template>
  <div class="page">
    <navigation adaption />
    <div class="top">
      <span class="back" @click="backHome">返回首页</span>
    </div>

    <div class="tips">
      <h3>免审额度提现，一次下款拿 <span class="red">{{ info.loanAmount }}元</span> ></h3>
      <div v-if="countdownVisible" class="tunnel-countdown">距离免审通道关闭 <van-count-down :time="countDownSeconds" @finish="countDownEnd">
        <template #default="timeData">
          {{ timeFormat(timeData.hours) }}:{{ timeFormat(timeData.minutes) }}:{{ timeFormat(timeData.seconds) }}
        </template>
      </van-count-down></div>
    </div>

    <div class="main-container">
      <div class="card">
        <div class="info">免审额度 (元)</div>
        <span class="important">{{ info.loanAmount | amount }}</span>
        <p>最终放款结果以资方审核为准，被拒2-7个工作日退款</p>
        <i class="mark"></i>
      </div>
      <div class="rate-container"></div>
      <div class="buy-container" @click="buy" data-sensors-click>
        <div class="disPrice">「免审额度」提现 ¥{{ info.discountPrice }}</div>
        <span class="price">原价 ¥{{ info.originalPrice }}</span>
        <span class="ui-bubble" v-if="expireTime-new Date().getTime()>0">
          <van-count-down
            :time="expireTime-new Date().getTime()"
            :format="dateFormat"
          />后涨价
        </span>
      </div>
      <div class="protocol">
        开通即同意<span @click="toProtocol">《会员用户协议》</span>
      </div>
    </div>

    <div class="privilege-card">
      <div class="header">
        <div class="title">更多精彩权益</div>
      </div>
      <div class="item-container">
        <img src="./images/auth-guide-pass/img_quanyi01@2x.png">
        <img src="./images/auth-guide-pass/img_quanyi02@2x.png">
        <img src="./images/auth-guide-pass/img_quanyi03@2x.png">
      </div>
    </div>
    <version-tips  v-model="showVersionTips" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { hasNativeMethod, jsBridge } from '../../assets/jsBridge'
import { isAndroid, versionStringCompare, getKey } from '@/assets/utils'
import { WHPay } from '@/assets/buyVip'
import CountDownTool from '@/assets/CountDownTool.js'
export default {
  async mounted () {
    await this.getDetailInfo()
    await this.setCountDownTime()
    this.$bus.$emit('ready')
  },
  data () {
    return {
      expireTime: 0,
      showVersionTips: false,
      info: {
        loanAmount: 0,
        discountPrice: 0,
        originalPrice: 0,
        supplier: '',
        lifeBenefitList: [{
          icon: '',
          equityTitle: '',
          equityDesc: ''
        }]
      },
      countDownSeconds: 0
    }
  },
  computed: {
    countdownVisible () {
      return this.countDownSeconds > 0
    },
    dateFormat () {
      if (this.expireTime - new Date().getTime() > 86400000) {
        return 'DD天HH:mm:ss'
      } else if (this.expireTime - new Date().getTime() > 3600000) {
        return 'HH:mm:ss'
      } else {
        return 'mm:ss'
      }
    }
  },
  beforeDestroy () {
    clearTimeout(window.timer)
  },
  methods: {
    ...mapActions('withdraw', [
      'passCardRefusedDetail'
    ]),
    ...mapActions('user', ['getFloatViewInfo']),
    timeFormat (num) {
      if (num < 10) {
        return `0${num}`
      }
      return num === 0 ? '00' : num
    },
    showVersionTipsDiff () {
      return isAndroid() &&
        hasNativeMethod('getUserInfo') &&
        getKey('appVersion') &&
        versionStringCompare('1.8.1.6', getKey('appVersion')) > 0
    },
    async buy () {
      if (this.showVersionTipsDiff()) {
        this.showVersionTips = true
        return
      }
      WHPay(false)
    },
    countDownEnd () {
      this.countDownSeconds = 0
      localStorage.setItem(CountDownTool.Keys.PassCardCountDownTimeStamp, 0)
    },
    async getDetailInfo () {
      const res = await this.passCardRefusedDetail()
      if (res.success) {
        const maxListCount = Math.min(3, res.data.lifeBenefitList.length)
        res.data.lifeBenefitList = res.data.lifeBenefitList.slice(0, maxListCount)
        this.info = res.data
        this.expireTime = res.data.expireTime
        window.timer = setTimeout(() => {
          this.expireTime = 0
        }, this.expireTime - new Date().getTime())
      }
    },
    async setCountDownTime () {
      const time = localStorage.getItem(CountDownTool.Keys.PassCardCountDownTimeStamp)
      if (time && time !== 0) {
        // 本地有倒计时数据
        const timeStamp = parseInt(time)
        const now = Date.now()
        if (now < timeStamp) {
          // 当前时间小于倒计时结束时间，继续倒计时
          this.countDownSeconds = timeStamp - now
        } else {
          // 当前时间大于等于倒计时结束时间，清空本地倒计时数据并重新获取倒计时
          localStorage.setItem(CountDownTool.Keys.PassCardCountDownTimeStamp, 0)
          await this.getFloatViewInfoX()
        }
      } else {
        // 本地没有倒计时数据，重新获取倒计时信息
        await this.getFloatViewInfoX()
      }
    },
    toProtocol () {
      if (this.info.supplier === 'JI_WEI') {
        this.$router.push('/protocol/vip-jw')
      } else if (this.info.supplier === 'WH') {
        this.$router.push('/protocol/vip-wh')
      } else {
        this.$router.push('/protocol/vip')
      }
    },
    async getFloatViewInfoX () {
      const response = await this.getFloatViewInfo({
        showPlace: 'HOME'
      })
      const { success, data } = response
      if (success) {
        this.countDownSeconds = data.passCardFloatBean?.channelCountDownTime * 1000
        const timeStamp = Date.now() + this.countDownSeconds
        localStorage.setItem(CountDownTool.Keys.PassCardCountDownTimeStamp, timeStamp)
        if (hasNativeMethod(CountDownTool.Keys.AndroidNativeCountDownMethod)) {
          jsBridge(CountDownTool.Keys.AndroidNativeCountDownMethod, { time: timeStamp })
        }
      }
    }

  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page {
  background: #F7F1EB;
  padding: 0 30px;
  padding-bottom: 30px;
  .red {
    color: #FF4633;
  }
  .privilege-card {
    margin-top: 20px;
    margin-bottom: 40px;
    width: 690px;
    height: 359px;
    display: flex;
    flex-direction: column;
    background: #FFFFFF;
    box-shadow: 0px 10px 20px 0px rgba(211,211,211,0.5);
    border-radius: 20px;
    padding: 25px 30px;
    .header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .title {
        font-size: 34px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 48px;
      }
    }
    .item-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-top: 30px;
      img {
        width: 197px;
        height: 231px;
      }
    }
  }
  @keyframes identifier {
    from{
      transform: scale(.7);
    }
    to {
      transform: scale(1);
    }
  }
  .buy-container {
    width: 630px;
    height: 88px;
    background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
    border-radius: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    margin:30px 0;
    margin-top: 50px;
    animation: identifier 1s  infinite alternate;
    position: relative;
    .ui-bubble {
      background: rgba(0,0,0,0.8);
      border-radius: 20px 20px 20px 0px;
      color: #fff;
      font-size: 20px;
      padding: 4px 20px;
      position: absolute;
      left: 44%;
      top: -25px;
      display: flex;
      height: 44px;
      align-items: center;
      .van-count-down {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffd8bc;
        line-height: 33px;
      }
    }

    .disPrice {
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #FFFFFF;
    }
    .price{
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      text-decoration: line-through;
      margin-left: 16px;
      opacity: 0.6;
    }
  }
  .protocol {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 33px;
    margin-top: 30px;
    padding-bottom: 60px;
    text-align: center;
    span {
      color: #8EB2D8;
    }
  }
  .tips {
    width: 690px;
    height: 140px;
    background: #FFFFFF;
    box-shadow: 0px 10px 20px 0px rgba(211,211,211,0.5);
    border-radius: 20px;
    padding: 25px 30px;
    h3 {
      font-size: 34px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    p {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }

    .tunnel-countdown {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 33px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .van-count-down {
        margin: 0 5px;
        font-size: 24px;
        color: #FF4633;
      }
    }
  }
  .rate-container {
    width:631px;
    height:112px;
    margin: 10px auto;
    background: url('./images/auth-guide-pass/img_a@2x.png') no-repeat;
      background-size: 100% 100%;
  }
  .top {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    padding:30px 0;
    margin-bottom: 30px;
    .back {
      float: right;
      text-decoration: underline;
      text-align: right;
    }
    .withdraw {
      float: right;
      text-align: right;
    }
  }
  .main-container {
    width: 690px;
    height: 735px;
    background: #FFFFFF;
    box-shadow: 0px 10px 20px 0px rgba(211,211,211,0.5);
    padding: 20px;
    margin-top: 20px;
    border-radius: 20px;
    .card {
      width:650px;
      height:350px;
      background: url('./images/auth-guide-pass/img_card@2x.png') no-repeat;
      background-size: 100% 100%;
      display: flex;
      position: relative;
      color: #fff;
      flex-direction: column;
      align-items: center;
      .mark {
        width:310px;
        height:60px;
        background: url('./images/auth-guide-pass/img_mianshen@2x.png') no-repeat;
        background-size: contain;
        position: absolute;
        right: 30px;
        top:40px
      }
      .info {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        margin-top:110px;
      }
      .important {
        font-size: 80px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
        color: #FFFFFF;
        margin-top: -5px;
      }
      &>p {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        padding-top: 5px;
        opacity: .7;
      }
    }
  }
}

</style>